/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import { getRequest } from 'apis/ApiInstence';
import axiosInstance from 'apis/axiosConfig';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom';

const EditMentor = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        mobile: '',
        expertise: '',
        qualification: '',
        designation: '',
        company: '',
        bio: '',
        image: null
    });
    const [existingImage, setExistingImage] = useState('');
    const [loading, setLoading] = useState(false);
    const [fetching, setFetching] = useState(true);

    useEffect(() => {
        const fetchMentor = async () => {
            try {
                const res = await getRequest(`mentors/${id}`);
                const data = res?.data;
                if (data) {
                    const user = data.user || {};
                    setFormData({
                        firstName: user.firstName || '',
                        lastName: user.lastName || '',
                        email: user.email || '',
                        mobile: user.mobile || '',
                        expertise: data.expertise || '',
                        qualification: data.qualification || '',
                        designation: data.designation || '',
                        company: data.company || '',
                        bio: data.bio || '',
                        image: null
                    });
                    setExistingImage(data.image || '');
                }
            } catch (err) {
                console.error(err);
                toast.error("Failed to load mentor details");
            } finally {
                setFetching(false);
            }
        };
        fetchMentor();
    }, [id]);

    const handleChange = (e) => {
        if (e.target.name === 'image') {
            setFormData({ ...formData, image: e.target.files[0] });
        } else {
            setFormData({ ...formData, [e.target.name]: e.target.value });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const submitData = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key] !== null && formData[key] !== undefined) {
                submitData.append(key, formData[key]);
            }
        });

        try {
            await axiosInstance.put(`/mentors/admin/${id}`, submitData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            toast.success("Mentor profile updated successfully!");
            navigate('/mentors');
        } catch (error) {
            console.error(error);
            toast.error(error?.response?.data?.message || "Failed to update mentor");
        } finally {
            setLoading(false);
        }
    };

    if (fetching) return <div className="text-center mt-5">Loading...</div>;

    return (
        <div className='container-fluid mt-5 mb-5'>
            <div className='mainheadig mx-4 mb-4 d-flex justify-content-between align-items-center'>
                <h4 className='text-white font-weight-bold'>Edit Mentor Profile</h4>
                <button className="btn btn-light" onClick={() => navigate(-1)}>Back</button>
            </div>
            <form onSubmit={handleSubmit} className="mx-4 p-4 card shadow">
                <div className='row'>
                    <div className='col-12 mb-3'>
                        <h5 className="border-bottom pb-2">Personal Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>First Name *</label>
                        <input type='text' name='firstName' className='form-control' value={formData.firstName} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Last Name</label>
                        <input type='text' name='lastName' className='form-control' value={formData.lastName} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Email *</label>
                        <input type='email' name='email' className='form-control' value={formData.email} onChange={handleChange} required />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Mobile *</label>
                        <input type='text' name='mobile' className='form-control' value={formData.mobile} onChange={handleChange} required />
                    </div>

                    <div className='col-12 mb-3 mt-4'>
                        <h5 className="border-bottom pb-2">Professional Details</h5>
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Expertise Area *</label>
                        <input type='text' name='expertise' className='form-control' value={formData.expertise} onChange={handleChange} placeholder="e.g. Marketing, AI, Legal" required />
                    </div>
                    <div className='col-md-6 form-group'>
                        <label className='admin-label font-weight-bold'>Qualification</label>
                        <input type='text' name='qualification' className='form-control' value={formData.qualification} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Company / Organization</label>
                        <input type='text' name='company' className='form-control' value={formData.company} onChange={handleChange} />
                    </div>
                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Designation</label>
                        <input type='text' name='designation' className='form-control' value={formData.designation} onChange={handleChange} />
                    </div>
                    
                    <div className='col-sm-12 form-group mt-3'>
                        <label className='admin-label font-weight-bold'>Bio / About</label>
                        <textarea name='bio' className='form-control' rows="3" value={formData.bio} onChange={handleChange}></textarea>
                    </div>

                    <div className='col-md-6 form-group mt-3'>
                        <label className='admin-label font-weight-bold d-block'>Profile Image (Leave empty to keep existing)</label>
                        {existingImage && <img src={`${process.env.REACT_APP_BACKEND}uploads/${existingImage}`} alt="Current Profile" width="50" className="mb-2 mr-3" style={{borderRadius: '50%'}} />}
                        <input type='file' name='image' className='form-control-file d-inline-block' onChange={handleChange} accept="image/*" />
                    </div>

                    <div className='col-12 mt-4 text-center'>
                        <button type='submit' className='btn btn-primary px-5 font-weight-bold' disabled={loading}>
                            {loading ? 'Updating...' : 'Update Profile'}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EditMentor;
